import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ICommunityEngagementActions, IThunkGetMonthlyRecord } from '../types';

const onGetMonthlyRecord: IThunkGetMonthlyRecord = thunk(
  async ({ setMonthlyRecord }: Actions<ICommunityEngagementActions>, payload) => {
    const { signal, ...request } = payload;

    setMonthlyRecord(null);
    const record = await api.communityEngagement
      .getMonthlyRecord(request, signal)
      .then(response => response.data);

    setMonthlyRecord(record);
  },
);

export default onGetMonthlyRecord;
